import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { upperFirst } from 'lodash';

import UserDashboardStore from 'js/stores/pages/AdminDashboardPage/UserDashboardStore';
import LoadingSpinner from '../../LoadingSpinner';

import DashPanel from '../../DashPanel';
import Header from '../../DashPanel/Header';
import Content from '../../DashPanel/Content';
import Pagination from '../../DashPanel/Pagination';
import Search from '../../DashPanel/Search';
import DropMenu from '../../DashPanel/DropMenu';
import Title from '../../DashPanel/Title';
import Controls from '../../DashPanel/Controls';

import Link from './Link';
import GotoItem from './GotoItem';
import User from './User';
import Created from './Created';
import UserLogo from './UserLogo';
import NotFound from './NotFound';

@observer
export default class Dashboard extends Component {
  userList = UserDashboardStore.create({ page: parseInt(this.props['*']) || 1 });

  constructor(props) {
    super(props);
    this.userList.load();
  }

  componentDidUpdate() {
    this.userList.setPage(this.props['*']);

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('f') && urlParams.has('q')) {
      this.userList.setQueryParams({
        field: urlParams.get('f'),
        query: urlParams.get('q'),
      });
    }
  }

  render() {
    return (
      <DashPanel>
        <Header>
          <DropMenu />
          <Title>Users</Title>
          <Controls>
            <Search model={this.userList} options={{ name: 'Name', email: 'Email address' }} />
            <Pagination model={this.userList} />
          </Controls>
        </Header>

        <Content>
          {this.userList.isLoading ? (
            <LoadingSpinner />
          ) : this.userList.users.length ? (
            <div>
              {this.userList.users.map(user => (
                <Link key={user.email} to={`user/${user.email}`}>
                  <UserLogo type={user.registration_method} />
                  <Created>{user.created_at}</Created>
                  <User>
                    {user.name || 'Unknown name'} ({user.email})
                  </User>
                  <GotoItem />
                </Link>
              ))}
            </div>
          ) : (
            <NotFound>No users found</NotFound>
          )}
        </Content>
      </DashPanel>
    );
  }
}
